import { HIDE_SMALL_BALANCES_KEY } from '@client/constants/settings';

export const setHideSmallBalances = (value: boolean) => window.localStorage.setItem(
  HIDE_SMALL_BALANCES_KEY,
  JSON.stringify(value),
);

export const getHideSmallBalances = () => window.localStorage.getItem(HIDE_SMALL_BALANCES_KEY) === 'true';
